import { keyframes } from '@emotion/react';

export const fadeIn = keyframes`
  from {
    opacity: 0;
    visibility: hidden;
  }

  to {
    opacity: 1;
    visibility: visible;
  }
`;

export const fadeOut = keyframes`
  from {
    opacity: 1;
    visibility: visible;
  }

  to {
    opacity: 0;
    visibility: hidden;
  }
`;

export const fadeInLeft = keyframes`
  from {
    opacity: 0;
    visibility: hidden;
    transform: translateX(-100%);
  }

  to {
    opacity: 1;
    visibility: visible;
    transform: translateX(0);
  }
`;

export const fadeInDown = keyframes`
  from {
    opacity: 0;
    visibility: hidden;
    transform: translate3d(0, -40px, 0);
  }

  to {
    opacity: 1;
    visibility: visible;
    transform: translate3d(0, 0, 0);
  }
`;

export const fadeOutUp = keyframes`
  from {
    opacity: 1;
    visibility: visible;
    transform: translate3d(0, 0, 0);
  }

  to {
    opacity: 0;
    visibility: hidden;
    transform: translate3d(0, -40px, 0);
  }
`;